const firebaseConfig = {
    apiKey: "AIzaSyAelFRh5UwST4k0ogJOiSwomFu8tPvLJAQ",
    authDomain: "book-hunt-c1c63.firebaseapp.com",
    projectId: "book-hunt-c1c63",
    storageBucket: "book-hunt-c1c63.appspot.com",
    messagingSenderId: "1018103205643",
    appId: "1:1018103205643:web:799589bfe06252eb431c0e"
  };
  export default firebaseConfig;